import React from "react";
import { CloseCircleFilled } from "@ant-design/icons";
import "./index.css";

const CloseButton = () => {
  return <CloseCircleFilled id="close-button" />;
};

export default CloseButton;
